import { useDispatch } from "react-redux";
import {
  QUERY_INTERVENTIONS_DATA,
  SUBSCRIBE_NEW_INTERVENTIONS_DATA,
} from "../queries/interventionsQueries";
import { useQuery } from "@apollo/client/react/hooks/useQuery";
import { useSubscription } from "@apollo/client/react/hooks/useSubscription";
import { useEffect } from "react";
import { setInterventionsData } from "../../../state/interventionsReducer";

export function QueryInterventionsData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_INTERVENTIONS_DATA);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setInterventionsData(data.getInterventionsData));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeNewInterventionsData() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_NEW_INTERVENTIONS_DATA, {
    onData: (x) => {
      const newInterventionsData = x.data.data.newInterventionsData;
      console.log("Received new interventions data:", newInterventionsData);
      dispatch(setInterventionsData(newInterventionsData));
    },
  });
  if (error) {
    console.log(error);
  }
}
